import {
  ProductType,
  isRCFOffer,
} from 'components/SummaryCard/SummaryCard.helpers';
import { TIntroducerApplication } from 'lendingApi/applications.types';

/**
 * Returns the product type of the offer the customer has selected, if any.
 * Returns undefined when no offer is selected (e.g. pre-decision states).
 */
export const getSelectedProductType = (
  application: TIntroducerApplication,
  isDE: boolean,
): ProductType | undefined => {
  const selected = application.formal_offer_sets?.[0]?.formal_offers?.find(
    (o) => o.is_selected,
  );
  if (!selected) return undefined;
  return isRCFOffer(selected, isDE) ? ProductType.RCF : ProductType.FLEXI;
};

/**
 * Returns the product types offered to the customer.
 * Returns an empty array when no formal offer set exists yet.
 */
export const getOfferedProductTypes = (
  application: TIntroducerApplication,
  isDE: boolean,
): ProductType[] => {
  const offers = application.formal_offer_sets?.[0]?.formal_offers ?? [];

  const result: ProductType[] = [];
  if (offers.some((o) => !isRCFOffer(o, isDE))) result.push(ProductType.FLEXI);
  if (offers.some((o) => isRCFOffer(o, isDE))) result.push(ProductType.RCF);
  return result;
};
